// extracted by mini-css-extract-plugin
export default {"popover-wrapper":"_1fl9R","popoverWrapper":"_1fl9R","root":"_1CEGH","close-button-padding":"_3-tqK","closeButtonPadding":"_3-tqK","close-button":"_1AQ0p","closeButton":"_1AQ0p"};